import type { SairAccount } from "@opencode/schema/sair-account"

// Only for the native Access account projection, never Workspace browser auth.
export function remoteEligibility(profile?: SairAccount.Profile) {
  if (profile?.compute === undefined) return "unknown"
  if (!profile.compute) return "denied"
  if (!profile.remoteWorkspace) return "unconfigured"
  return "available"
}
